import { Box } from "@chakra-ui/react";
import { ReactComponent as BGError } from "../assets/error-bg.svg";
import { Link } from "@reach/router";
import { useSelector } from "react-redux";
import { useProfileContext } from "newui/features/Auth/context/ProfileContext";
import { ReactNode } from "react";
import { useAuthContext } from "newui/features/Auth/context/AuthContextProvider";
import Heading from "newui/components/ui/Heading";
import { theme } from "theme";

interface ErrorPageProps {
	children?: ReactNode;
	errorCode: string;
	message?: string;
	showExtendButton?: boolean;
	title: string;
	onExtendAccess?: () => void;
}

export const BaseErrorPage: React.FC<ErrorPageProps> = ({
	children,
	errorCode,
	message,
	showExtendButton = false,
	title,
	onExtendAccess,
}) => {

	const { clientPaths, supplierPaths, guestPaths } = useAuthContext();

	const { isClientProfileActive } = useProfileContext();

	const homePage = (isClientProfileActive ? clientPaths?.home : supplierPaths?.home) ?? guestPaths?.home;

	return (
		<Box className="w-full h-full flex align-middle justify-center">
			<div className="relative mx-auto mt-[10vh] h-[90vh] max-h-[680px] w-full max-w-[1280px] overflow-hidden">
				<BGError className="absolute left-1/2 top-1/2 z-10 w-full h-full min-w-[750px] -translate-x-1/2 -translate-y-1/2
  " />
				<div className="relative top-[45%] z-20 -translate-y-1/2 space-y-6 text-center">
					<Heading fontSize="clamp(96px, 12vw, 160px)" lineHeight={"1"}>
						{errorCode}
					</Heading>
					<Heading fontSize="clamp(28px, 4vw, 48px)" className="text-utility-brand-300">
						{title}
					</Heading>
					<p className="font-roboto text-[clamp(16px,2vw,20px)] text-white">
						{message || children}
					</p>
					<div className="!mt-12 flex justify-center gap-4">
						{showExtendButton && onExtendAccess && (
							<button
								onClick={onExtendAccess}
								className="block h-[60px] rounded-sm !bg-utility-brand-300 px-6 py-4 font-roboto font-semibold leading-[30px] !text-royal-blue hover:opacity-90"
							>
								Extend Access
							</button>
						)}
						{homePage && (
							<Link
								className="block h-[60px] w-[200px] rounded-sm !bg-white px-6 py-4 font-roboto font-semibold leading-[30px] !text-royal-blue hover:opacity-90"
								to={homePage}
							>
								Return to homepage
							</Link>
						)}
					</div>
				</div>
			</div>
		</Box>
	);
};